import { useAgencyStore } from '@/stores/agency'
import { defineStore } from 'pinia'
import AvailValidate from './AvailValidate'
import axios from '@/plugins/axios'
import { QUERY_SERVICE_TYPE, SERVICE_TYPE, FLIGHT_TYPE } from '@/utilities/flight/santsg/constants'

import { reserveValidationData } from './utl.js'
import { options } from 'sanitize-html'

const buildDates = (dates) => {
  // /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})([+-])(\d{2}):(\d{2})$/

  return dates
}

const getDates = (type, destinations) => {
  let start = ''
  let end = ''

  if (type === SERVICE_TYPE.ONE_WAY || type === FLIGHT_TYPE['one-way']) {
    start = destinations[0]?.start || ''
    end = start
  } else if (type === SERVICE_TYPE.ROUND_TRIP || type === FLIGHT_TYPE['round-trip']) {
    start = destinations[0].start
    end = destinations[0].end

  } else if (type === SERVICE_TYPE.MULTI_CITY || type === FLIGHT_TYPE['multi-city']) {
    start = destinations[0].start
    end = destinations[destinations.length - 1].start
  }

  return {
    start,
    end
  }
}
const transportTitle = (titles) => {
  return titles.map((t) => {
    return {
      value: t?.id,
      label: t?.name
    }
  })
}

const buildDestinationBooking = (destinations) => {
  return destinations.map((d) => {
    delete d.check_in_dates
    return {
      ...d
    }
  })
}
const getDestinations = (type, destinations) => {
  const _destinations = destinations.map((d) => {
    let start = d?.start || ''
    let end = d?.end || ''
    return {
      origin: {
        id: d.origin.id,
        type: d.origin.type
      },
      destiny: {
        id: d.destination.id,
        type: d.destination.type
      },
      start,
      end
    }
  })

  if (type === 'multi-city') {
    return _destinations
  }
  return [_destinations[0]]
}

const initialState = () => {
  return {
    destinations: [
      {
        origin: {},
        destination: {},
        start: '',
        end: '',
        check_in_dates: [],
        first_date: '',
        last_date: ''
      },
      {
        origin: {},
        destination: {},
        start: '',
        end: '',
        check_in_dates: [],
        first_date: '',
        last_date: ''
      }
    ],
    errors: [],
    payments: {},
    segments: {},
    airlines: {},
    segmentsData: {},
    flight: {},
    flightOptions: {},
    flightSegments: [],
    flights: [],
    flightType: '',
    totalPages: 0,
    page: 0,
    cacheId: '',
    nextPage: '',
    beforePage: '',
    service_type: 2,
    rangePrice: [0, 0],
    cancelPolicies: [],
    options: [],
    offersSelected: {
      departure: [],
      arrival: []
    },
    offersMultiSelected: {},
    modal: false,
    police_dialog: false,
    country: '',
    countryCode: '',
    provider_id: '',
    keyword: '',
    numberOfAdults: 2,
    numberOfChildren: 0,
    availableTitles: [
      {
        value: '1',
        label: 'Mr'
      },
      {
        value: '2',
        label: 'Ms'
      },
      {
        value: '3',
        label: 'Mrs'
      },
      {
        value: '4',
        label: 'Miss'
      }
    ],
    pages: [],
    page: 0,
    limit: 10,
    cacheExpire: false,
    totalNumberOfPeople: 2,
    reserve: {
      bookingInfo: {},
      companionRequiredFields: {},
      availableTitles: [],
      companions: [],
      payments: {},
      paymentsOptions: {},
      holder: {},
      detailProvider: {},
      price: 0,
      bookingCodes: [],
      currency: '',
      transactionId: '',
      flightType: '',
      cancelPolicies: '',
      expiresOn: '',
      country: '',
      observations: '',
      comments: '',
      destinations: [],
      cancellationPolicies: []
    },
    paxes: [
      {
        numberOfPeople: 2,
        children: 0,
        childrenAge: [],
        adults: 2,
        adultsAge: [30, 30]
      }
    ],
    version: '0.0.1'
  }
}
export default defineStore('flightSantsg', {
  state: () => ({
    destinations: [
      {
        origin: {},
        destination: {},
        start: '',
        end: '',
        check_in_dates: [],
        first_date: '',
        last_date: ''
      },
      {
        origin: {},
        destination: {},
        start: '',
        end: '',
        check_in_dates: [],
        first_date: '',
        last_date: ''
      }
    ],
    errors: [],
    payments: {},
    segments: {},
    airlines: {},
    segmentsData: {},
    airports: {},
    flight: {},
    flightOptions: {},
    flightSegments: [],
    flights: [],
    flightType: '',
    itemFound: 0,
    totalPages: 0,
    page: 0,
    cacheId: '',
    nextPage: '',
    beforePage: '',
    service_type: 2,
    rangePrice: [0, 0],
    cancelPolicies: [],
    options: [],
    offers: {},
    optionSelected: {},
    offersSelected: {
      departure: [],
      arrival: []
    },
    offersMultiSelected: {},
    modal: false,
    police_dialog: false,
    country: '',
    countryCode: '',
    flightClass: '',
    provider_id: '',
    keyword: '',
    numberOfAdults: 2,
    numberOfChildren: 0,
    pages: [],
    availableTitles: [
      {
        value: '1',
        label: 'Mr'
      },
      {
        value: '2',
        label: 'Ms'
      },
      {
        value: '3',
        label: 'Mrs'
      },
      {
        value: '4',
        label: 'Miss'
      }
    ],
    page: 0,
    limit: 10,
    cacheExpire: false,
    totalNumberOfPeople: 2,
    reserve: {
      companionRequiredFields: {},
      availableTitles: [],
      bookingInfo: {},
      companions: [],
      services: [],
      payments: {},
      holder: {
        name: '',
        surname: '',
        nationalityCode: '',
        birthDate: '',
        doc: '',
        documentType: '',
        country: '',
        address: '',
        email: '',
        phone: '',
        age: 30,
        passportInfo: {
          serial: '',
          number: '',
          expireDate: '',
          issueDate: '',
          citizenshipCountryCode: ''
        }
      },
      price: 0,
      bookingCodes: [],
      currency: '',
      country: '',
      start: '',
      end: '',
      observations: '',
      destinations: [],
      cancellationPolicies: []
    },
    paxes: [
      {
        numberOfPeople: 2,
        children: 0,
        childrenAge: [],
        adults: 2,
        adultsAge: [30, 30]
      }
    ],
    version: '0.0.1'
  }),
  actions: {
    addTramo() {
      if (this.destinations.length >= 2) {
        this.destinations.push({
          origin: {},
          destination: {},
          start: '',
          end: '',
          check_in_dates: [],
          first_date: '',
          last_date: ''
        })
      }
    },
    removeTramo(index) {
      if (this.destinations.length > 2) {
        this.destinations.splice(index, 1)
      }
    },
    setOption(index, option) {
      const position = index + 1
      if (this.options.length < position) {
        this.options.push({})
      }
      this.options[index] = option
    },
    setOptionsSelected(index, value) {
      this.optionSelected[index] = value
    },

    setOffers(index, offers) {
      console.log('setOffers', index, offers)
      if (!this.offers[index]) {
        this.offers[index] = offers
      }
    },

    /**
     * Sets the offer for a given tramo index
     * @param {number} index - The index of the tramo
     * @param {object} option - The selected offer
     */
    setOffer(index, type = '', offer) {
      /*
       */
      const position = index + 1
      const qty = this.offersSelected?.[type]?.length || 0
      if (qty < position) {
        this.offersSelected[type].push({})
      }
      this.offersSelected[type][index] = offer
    },
    setOffersMultiSelected(index, offer, item = {}) {
      if (!this.offersMultiSelected[index]) {
        this.offersMultiSelected[index] = {}
      }

      /**/
      if (Object.keys(offer).length) {
        delete item.offers
        // offer['parent'] = item
      }
      /**/
      this.offersMultiSelected[index] = offer
    },
    async checkInDates(index) {
      if (!QUERY_SERVICE_TYPE[this.service_type]) return
      if (!this.destinations[index]) return

      const { origin, destination } = this.destinations[index]
      if (!(origin.id && origin.type) || !(destination.id && destination.type)) return

      const response = await axios.post(
        '/api/integrator/santsg/flight/booking/avail/checkindates',
        {
          serviceType: QUERY_SERVICE_TYPE[this.service_type],
          origin: {
            id: origin.id,
            type: origin.type
          },
          destiny: {
            id: destination.id,
            type: destination.type
          }
        },
        {
          validateStatus: function (status) {
            return status <= 404
          }
        }
      )

      if (response.data?.dates?.length) {
        this.destinations[index].check_in_dates = buildDates(response.data.dates)
        this.destinations[index].first_date = response.data.dates[0]
        this.destinations[index].last_date = response.data.dates[response.data.dates.length - 1]
      } else {
        this.destinations[index].check_in_dates = []
      }
    },
    async resetSearch() {
      this.totalPages = 0
      this.page = 0
      this.cacheId = ''
      this.nextPage = ''
      this.beforePage = ''
      this.isQuery = false
      this.cacheExpire = false
      this.errors = []
      this.flight = {}
      this.flights = []
      this.flightOptions = {}
      this.options = []
      this.segments = {}
      this.airlines = {}
      this.flightSegments = {}
      this.offersMultiSelected = {}
    },
    async avail(cbk = null) {
      const agencyStore = useAgencyStore()
      let url = `api/integrator/santsg/flight/booking/avail/price-search`

      let response = null

      this.resetSearch()

      const test = agencyStore?.mode === 'production' ? false : true

      // const end= this.end
      const paxes = this.paxes?.[0] || {}
      const serviceType = QUERY_SERVICE_TYPE[this.service_type] || ''
      const country = this.country
      const countryCode = this.countryCode
      const keyword = this.keyword
      const destination = this.destination
      const numberOfAdults = this.numberOfAdults
      const numberOfChildren = this.numberOfChildren
      const totalNumberOfPeople = this.totalNumberOfPeople
      const provider_id = this.provider_id

      const { adultsAge: adults = [], childrenAge: children = [] } = { ...paxes }

      const destinations = getDestinations(serviceType, this.destinations)
      const { start = '', end = '' } = getDates(serviceType, this.destinations)

      const provider = this.provider_id
      const providers = this.provider_id ? [this.provider_id] : []
      const payload = {
        providers,
        provider,
        // destinationCityCode: destination?.destinationCityCode,
        // countryCode: countryCode,
        serviceType,
        destinations,
        showOnlyNonStopFlight: false,
        flightClass: this.flightClass,
        culture: 'en-US',
        currency: 'USD',
        start,
        end,
        paxes: { adults, children },
        simulate: false
      }

      const availValidate = new AvailValidate(payload)
      const error = availValidate.validate()

      if (error?.status) {
        this.errors = error.errors
        return
      }

      this.preload = true
      this.flights = []

      response = await axios.post(`${url}`, payload, {
        validateStatus: function (status) {
          return status <= 404
        }
      })

      const {
        success = false,
        items = [],
        segments = {},
        segmentsData = {},
        airlines = {},
        airports = {},
        lowestPrice = 0,
        highestPrice = 0,
        itemFound = 0,
        expires = 0,
        totalPages = 0,
        page = 0,
        cacheId = '',
        next: nextPage = '',
        before: beforePage = '',
        msg: message = ''
      } = { ...response?.data }

      if (success) {
        this.segments = segments || {}
        this.airlines = airlines || {}
        this.airports = airports || {}
        this.segmentsData = segmentsData || {}
        this.flights = items || []
        this.lowestPrice = lowestPrice
        this.highestPrice = highestPrice
        this.expires = expires
        this.itemFound = itemFound
        this.rangePrice = [lowestPrice, highestPrice]
        this.preload = true
        this.totalPages = totalPages
        this.page = page
        this.cacheId = cacheId
        this.nextPage = nextPage
        this.beforePage = beforePage
      }

      if (cbk && typeof cbk === 'function') {
        cbk({
          message,
          success,
          flights: this.flights
        })
      }
    },
    async startReservation(payload) {
      const {
        bookingInfo = {},
        flightType = '',
        options = [],
        companions = [],
        bookingCodes = [],
        payments = {}
      } = { ...payload }

      const response = await this.preReserve({
        flightType,
        payments
      })

      if (response?.error) {
        return {
          success: false,
          message: response.msg
        }
      }

      const {
        transactionId = '',
        expiresOn = '',
        cancelPolicies = [],
        destinations = [],
        payments: paymentsReserve = {},
        detailProvider = {},
        companionRequiredFields = {},
        availableTitles = [],
        services = []
      } = { ...response }

      const { start = '', end = '' } = getDates(flightType, this.destinations)
      const titles = availableTitles.length ? transportTitle(availableTitles) : this.availableTitles

      this.reserve.bookingInfo = bookingInfo
      this.reserve.services = services
      this.reserve.start = start
      this.reserve.end = end
      this.reserve.companionRequiredFields = companionRequiredFields
      this.reserve.availableTitles = titles
      this.reserve.options = options
      this.reserve.companions = companions
      this.reserve.destinations = destinations
      this.reserve.bookingCodes = bookingCodes
      this.reserve.paymentsOptions = payments
      this.reserve.detailProvider = detailProvider
      this.reserve.payments = paymentsReserve
      this.reserve.transactionId = transactionId
      this.reserve.cancellationPolicies = cancelPolicies
      this.reserve.expiresOn = expiresOn
      this.reserve.flightType = flightType
      this.reserve.price = paymentsReserve?.client || 0
      this.reserve.currency = paymentsReserve?.currency || ''
      this.reserve.holder = {
        name: '',
        surname: '',
        nationalityCode: '',
        birthDate: '',
        doc: '',
        country: '',
        age: 30,
        passportInfo: {
          serial: '',
          number: '',
          expireDate: '',
          issueDate: '',
          citizenshipCountryCode: ''
        }
      }

      return {
        success: true,
        message: 'Pre reserve successfully'
      }
    },
    async preReserve({ flightType = '', payments = {} }) {
      const url = `/api/voucher/start-reserve`
      const agencyStore = useAgencyStore()
      const test = agencyStore?.mode === 'production' ? false : true
      const destinations = getDestinations(flightType, this.destinations)
      const { adultsAge: adults = [], childrenAge: children = [] } = { ...this.paxes[0] }
      const bookingCodes = Object.values(this.offersMultiSelected)
        .map((offer) => offer?.bookingCodes)
        .flat()

      const data = {
        provider: this.provider_id,
        providers: [this.provider_id],
        bookingCodes: bookingCodes,
        destinations: destinations,
        paxes: { adults, children },
        showOnlyNonStopFlight: false,
        flightClass: this.flightClass,
        culture: 'en-US',
        currency: payments?.currency,
        status: 'pre-reserve',
        type: 'flight-santsg',
        integrator: 'santsg',
        serviceType: flightType,
        mode: test
      }

      const resp = await axios.post(`${url}`, data)

      return {
        ...resp?.data,
        destinations,
        flightType
      }
    },
    async booking({isEstimate = false}) {
      const agencyStore = useAgencyStore()
      //const { start = '', end = '' } = getDates(this.reserve.flightType, this.destinations)
      const destinations = getDestinations(this.reserve.flightType, this.destinations)

      const url = `api/voucher`
      const bookingCodes = this.reserve.bookingCodes
      const errors = reserveValidationData({
        ...this.reserve,
        bookingCodes,
        flightClass: this.flightClass
      })
      console.log(errors)
      if (errors?.errors) {
        this.errors = errors.data
        return {
          status: false,
          messages: errors?.data
        }
      }

      const data = {
        provider: this.provider_id,
        providers: [this.provider_id],
        bookingInfo: this.reserve.bookingInfo,
        flightNos: [],
        start: this.reserve.start,
        end: this.reserve.end,
        destinations: destinations,
        client: {
          name: `${this.reserve.holder?.name} ${this.reserve.holder?.surname}`,
          email: `${this.reserve.holder?.email}`,
          address: `${this.reserve.holder?.address}`,
          document: this.reserve.holder?.document,
          passportInfo: this.reserve.holder?.passportInfo,
          documentType: this.reserve.holder?.documentType,
          age: this.reserve.holder?.age,
          postalCode: this.reserve.holder?.postalCode,
          nationalityCode: this.reserve.holder?.nationalityCode,
          city: this.reserve.holder?.city,
          gender: this.reserve.holder?.gender,
          phones: [this.reserve.holder?.phone]
        },
        price: this.reserve.price,
        payments: this.reserve.payments,
        paymentsOptions: this.reserve.paymentsOptions,
        cancellationPolicies: this.reserve.cancellationPolicies,
        transactionId: this.reserve.transactionId,
        detailProvider: this.reserve.detailProvider,
        expiresOn: this.reserve.expiresOn,
        currency: this.reserve.currency,
        country: this.reserve.country,
        bookingCodes,
        companions: this.reserve.companions,
        options: this.reserve.options,
        // comments: this.reserve.comments,
        // observations: this.reserve.observations,
        flightType: this.reserve.flightType,
        services: this.reserve.services,
        flightClass: this.flightClass,
        type: 'flight-santsg',
        integrator: 'santsg',
        status: 'confirmed',
        mode: agencyStore?.mode,
        isEstimate
      }

      console.log('data', JSON.stringify(data, null, 2))

      const resp = await axios.post(`${url}`, data, {
        validateStatus: function (status = null) {
          return status <= 500
        }
      })
      return resp
    },
    reset1() {
      Object.assign(this, defineStore)
    }
  },
  persist: true
})
